import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4 operation-office-radio-form" }
const _hoisted_2 = {
  class: "pt-2 pl-4",
  style: {"font-weight":"bold"}
}

import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioForm',
  props: {
    modelValue: {},
    title: {},
    items: {},
    selectedItem: {},
    cols: {},
    windowInnerWidth: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "radio-form pl-4 pr-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(props.title), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, { cols: __props.cols }, {
          default: _withCtx(() => [
            _createVNode(_component_v_radio_group, {
              modelValue: modelValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
              class: "radio-group-row pt-2"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
                  return (_openBlock(), _createBlock(_component_v_radio, {
                    key: item.value,
                    value: item.value,
                    label: item.label,
                    color: "blue"
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(ValidationErrors, { messages: __props.errors }, null, 8, ["messages"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}
}

})